var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 49,
    viewBox: "0 0 143 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_623)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_215_623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9487 22.5907L0 49L4.86158 47.4531C8.94864 46.1527 13.1234 45.1461 17.354 44.441L20 44L30.5 43.5L39 44L41.646 44.441C45.8766 45.1461 50.0514 46.1527 54.1384 47.4531L59 49L58.5195 48.2525C55.8513 44.1021 52.6509 40.319 49 37C45.6952 33.3648 41.7459 30.3729 37.3517 28.1758L33 26C24.7976 22.0628 15.7392 20.2441 6.65278 20.7101L1 21L9 21.5L14.5 22H14.6042C14.8228 22 15 22.1772 15 22.3958C15 22.4641 14.9823 22.5313 14.9487 22.5907Z",
    fill: "#4478FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 2.5L18 17H20.5H22.5C24.8304 17 27.1578 17.1654 29.4648 17.495L29.5 17.5L34.5 18.5L39.5 20L43.5 21.5L33 2.5L32.6202 1.93026C32.2138 1.32065 31.6553 0.827655 31 0.5L30.8944 0.447214C30.3062 0.153113 29.6576 0 29 0C28.3597 0 27.7456 0.254354 27.2929 0.707107L27.1929 0.807067C27.0646 0.935375 26.9493 1.07604 26.8487 1.22702L26 2.5Z",
    fill: "#4478FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9538 41H64.7351L72.4162 19.1818H77.2955L84.9872 41H80.7685L74.9411 23.6562H74.7706L68.9538 41ZM69.0923 32.4453H80.598V35.62H69.0923V32.4453ZM87.861 19.1818H92.6976L99.1749 34.9915H99.4306L105.908 19.1818H110.744V41H106.952V26.0107H106.749L100.72 40.9361H97.8858L91.856 25.9787H91.6536V41H87.861V19.1818ZM119.001 19.1818V41H115.048V19.1818H119.001ZM141.211 19.1818V41H137.695L127.414 26.1385H127.233V41H123.281V19.1818H126.818L137.088 34.054H137.279V19.1818H141.211Z",
    fill: "#4478FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 49,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_215_623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.22d451169b8d8717396fe8be6d43096e.svg";
export { ForwardRef as ReactComponent };